import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/reset.less';
// quill 富文本编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import '@/assets/styles/iconfont/iconfont.css';
// import Blob from '@/jslibs/excel/Blob.js'
// import Export2Excel  from '@/jslibs/excel/Export2Excel.js'

//图片预览插件
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';

//引入iview
import {
	TimePicker
} from 'view-design';
import 'view-design/dist/styles/iview.css';

import {
	imgFilter
} from './filters/vue-filters';

require('./jslibs/verify-code.min');

Vue.prototype.bus = new Vue();


Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Viewer);
Vue.component('TimePicker', TimePicker);
Vue.filter('imgMapper', imgFilter);

import VueAMap from "vue-amap";
Vue.use(VueAMap);
window._AMapSecurityConfig = {
	securityJsCode: '20e2f706018b1926bdb5a99ecce763a5' // 输入你的jscode
}
VueAMap.initAMapApiLoader({
	key: "75cd22d430cac3ae940bda2e8983f54d", //高德开放平台申请的key值
	plugin: [
		"AMap.Autocomplete", //输入提示插件
		"AMap.PlaceSearch", //POI搜索插件
		"AMap.Scale", //右下角缩略图插件 比例尺
		"AMap.OverView", //地图鹰眼插件
		"AMap.ToolBar", //地图工具条
		"AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
		"AMap.Geocoder", // 逆地理编码,通过经纬度获取地址所在位置详细信息
		// 根据需求选用
	],
	uiVersion: "1.0", // 地图ui版本
	v: "1.4.4", // amap版本
});

window.vm = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
